import React from "react";

/*
 * WAXUM logo — unique custom mark.
 * Icon: hexagonal shield with two crossing sword-strokes forming a W/X hybrid.
 * Wordmark: bold italic display type, the X accented in signature green.
 */
export const LogoMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="wx-hex" x1="0" y1="0" x2="48" y2="48">
        <stop offset="0" stopColor="#39445e" />
        <stop offset="1" stopColor="#232a3d" />
      </linearGradient>
      <linearGradient id="wx-blade" x1="0" y1="0" x2="48" y2="48">
        <stop offset="0" stopColor="#7df5ac" />
        <stop offset="1" stopColor="#2ecc74" />
      </linearGradient>
    </defs>
    {/* hexagon shield */}
    <path
      d="M24 2 L43 12.5 V35.5 L24 46 L5 35.5 V12.5 Z"
      fill="url(#wx-hex)"
      stroke="#4a5674"
      strokeWidth="1.5"
    />
    {/* crossed sword strokes forming stylized X/W */}
    <path
      d="M13 14 L24 30 L35 14 L38 14 L25.6 32.2 L30 38 H26.6 L24 34.4 L21.4 38 H18 L22.4 32.2 L10 14 Z"
      fill="url(#wx-blade)"
    />
    {/* spark dot at the cross point */}
    <circle cx="24" cy="31" r="2.1" fill="#eafff2" />
  </svg>
);

const Logo = ({ size = "md", className = "" }) => {
  const text = { sm: "text-xl", md: "text-2xl", lg: "text-4xl" };
  return (
    <div className={`flex items-center select-none ${className}`}>
      <span
        className={`font-display font-extrabold italic tracking-tight ${text[size]} leading-none`}
        style={{ color: "#eef1f7" }}
      >
        WA<span style={{ color: "#3ddc84" }}>X</span>UM
      </span>
    </div>
  );
};

export default Logo;
